import Vue from 'vue'

const changeCSSVar = (property, newValue) => {
  const bodyStyles = document.body.style

  bodyStyles.setProperty(
    property,
    newValue || bodyStyles.getPropertyValue(property)
  )
}

export const DefaultTheme = () => ({
  primary: '#0273c3',
  secondary: '#ffffff',
  accent: '#37474F',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
})

export function changeRadius({
  cardRadius,
  btnRadius,
  smallBtnRadius,
  chipRadius,
  navDrawerColor,
  snackbarRadius,
  inputRadius,
}) {
  changeCSSVar('--component-card-radius', cardRadius)
  changeCSSVar('--zoox-snackbar-radius', snackbarRadius)
  changeCSSVar('--component-input-md-radius', inputRadius)
  changeCSSVar('--component-button-sm-radius', smallBtnRadius)
  changeCSSVar('--zoox-btn-radius', btnRadius)
  changeCSSVar('--component-chip-md-radius', chipRadius)
  changeCSSVar('--zoox-navigation-drawer-color', navDrawerColor)
}

export function changeTheme({vuetify}, {primary, cardShadow = false} = {}) {
  if (!vuetify) {
    throw new Error('Necessário adicionar vuetify')
  }
  const defaultTheme = DefaultTheme()

  vuetify.theme.themes.light.primary = primary || defaultTheme.primary
  Vue.prototype.$zoox.colors.primary = primary
  Vue.prototype.$zoox.cardShadow = cardShadow

  changeCSSVar('--primary', primary)
}

export const DesignSystemColors = {
  primary: '#0273c3',
  background: '#f4f4f4',

  // Brand Colors
  zooxblue: '#00bbd3',
  zooxlightblue: '#b2d2d6',

  // Light Blue
  lightblue: '#53a9d8',
  lightblue100: '#ddeef7',
  lightblue200: '#baddef',
  lightblue300: '#98cbe8',
  lightblue400: '#75bae0',
  lightblue500: '#53a9d8',
  lightblue600: '#3d93c1',
  lightblue700: '#28759f',
  lightblue800: '#135274',
  lightblue900: '#07364f',

  // Mid Blue
  midblue: '#0273c3',
  midblue100: '#cce3f3',
  midblue200: '#9ac7e7',
  midblue300: '#67abdb',
  midblue400: '#358fcf',
  midblue500: '#0273c3',
  midblue600: '#0062a8',
  midblue700: '#00528c',
  midblue800: '#003b65',
  midblue900: '#002a48',

  // Dark Blue
  darkblue: '#004c91',
  darkblue100: '#ccdbe9',
  darkblue200: '#99b7d3',
  darkblue300: '#6694bd',
  darkblue400: '#3370a7',
  darkblue500: '#004c91',
  darkblue600: '#003f79',
  darkblue700: '#003566',
  darkblue800: '#00294f',
  darkblue900: '#00203d',

  // White / Black
  white: '#fff',
  blackground: '#f4f4f4',
  black050: '#ececec',
  black100: '#ddd',
  black300: '#999',
  black600: '#666',
  black800: '#333',
  black: '#000',

  // ---- Secundárias -------
  magenta: '#a92374',
  magenta100: '#e7a2cc',
  magenta200: '#d57db2',
  magenta300: '#c05295',
  magenta400: '#af2f7c',
  magenta500: '#a92374',
  magenta600: '#8e2066',
  magenta700: '#801d5e',
  magenta800: '#5d0d41',
  magenta900: '#47032f',

  // Red
  red: '#d33246',
  red100: '#f6d6da',
  red200: '#edadb5',
  red300: '#e58490',
  red400: '#dc5b6b',
  red500: '#d33246',
  red600: '#c52639',
  red700: '#ad1d2f',
  red800: '#8e1120',
  red900: '#53000a',

  // Orange
  orange: '#ff8f28',
  orange100: '#ffe9d4',
  orange200: '#ffd2a9',
  orange300: '#ffbc7e',
  orange400: '#ffa553',
  orange500: '#ff8f28',
  orange600: '#dc6b19',
  orange700: '#bb5217',
  orange800: '#aa4308',
  orange900: '#763916',

  // Yellow
  yellow: '#ffc220',
  yellow100: '#fff3d2',
  yellow200: '#ffe7a6',
  yellow300: '#ffda79',
  yellow400: '#ffce4d',
  yellow500: '#ffc220',
  yellow600: '#d19218',
  yellow700: '#a55f0d',
  yellow800: '#88490f',
  yellow900: '#593103',

  // LightGreen
  lightgreen: '#49cb8c',
  lightgreen100: '#dbf5e8',
  lightgreen200: '#b6ead1',
  lightgreen300: '#92e0ba',
  lightgreen400: '#6dd5a3',
  lightgreen500: '#49c88c',
  lightgreen600: '#3db079',
  lightgreen700: '#30895e',
  lightgreen800: '#226645',
  lightgreen900: '#0e4128',

  // DarkGreen
  darkgreen: '#239465',
  darkgreen100: '#d3eae0',
  darkgreen200: '#a7d4c1',
  darkgreen300: '#7bbfa3',
  darkgreen400: '#4fa984',
  darkgreen500: '#239465',
  darkgreen600: '#1e7a54',
  darkgreen700: '#186746',
  darkgreen800: '#125237',
  darkgreen900: '#0c3323',

  // Purple
  purple: '#674099',
  purple100: '#e1d9eb',
  purple200: '#c2b3d6',
  purple300: '#a48cc2',
  purple400: '#8566ad',
  purple500: '#674099',
  purple600: '#542e85',
  purple700: '#411e6d',
  purple800: '#2b0f50',
  purple900: '#170232',
}

export const StorybookColors = Object.keys(DesignSystemColors).map(
  (colorKey) => {
    const matches = colorKey.match(/([a-zA-Z]+)([0-9]{3})/)

    if (matches !== null && matches.length > 2) {
      return `var(--${matches[1]}-${matches[2]})`
    }

    return `var(--${colorKey})`
  }
)
